import { createSlice } from '@reduxjs/toolkit';

import {
	handleAsyncThunkActionState,
	initialAsyncState,
	isAsyncThunkActionWithPrefix
} from '../utils';
import * as thunks from './thunks';

const initialState = {
	fetchPrices: initialAsyncState,
	fetchPayments: initialAsyncState,
	page: 1
};

const billingSlice = createSlice(
	{
		name: 'billing',
		initialState,
		reducers: {
			clearData() {
				return initialState;
			},
			setPage(state, { payload }) {
				state.page = payload;
			},
			setCanRegenerateInvoice(state, action) {
				const { rowId, value } = action.payload;
				state.rows[rowId].canRegenerateInvoice = value;
			}
		},
		extraReducers(builder) {
			builder.addCase(thunks.fetchPayments.fulfilled, (state, action) => {
				const { totalPages, rows } = action.payload;

				state.totalPages = totalPages;
				state.rows = rows;
				state.isEmpty = rows?.length === 0 && state.page === 1;

				if (totalPages && state.page > totalPages) {
					state.page = totalPages;
				}
			});

			builder.addMatcher(
				isAsyncThunkActionWithPrefix('billing'),
				handleAsyncThunkActionState
			);
		}
	},
	initialState
);

export const { clearData, setPage, setCanRegenerateInvoice } =
	billingSlice.actions;

export default billingSlice.reducer;
